import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import flogowhite from "../assets/images/flogowhite.png";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const currentLang = lang || i18n.language?.substring(0, 2) || 'en';
  
  // Generate language-prefixed path
  const getLocalizedPath = (path) => {
    return `/${currentLang}${path}`;
  };
  
  return (
    <footer className="bg-teal-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center mb-6">
          <img src={flogowhite} alt="Fast Affiliation" className="h-8" />
          <span className="ml-4 font-bold">Fast Affiliation</span>
        </div>
        
        <nav className="flex flex-wrap justify-center space-x-4 md:space-x-6 mb-6">
          <Link to={getLocalizedPath("")} className="text-white hover:text-teal-200">{t('header.home')}</Link>
          <Link to={getLocalizedPath("/faq")} className="text-white hover:text-teal-200">{t('header.faq')}</Link>
          <Link to={getLocalizedPath("/affiliation-program")} className="text-white hover:text-teal-200">{t('footer.affiliateProgram')}</Link>
          <Link to={getLocalizedPath("/contact")} className="text-white hover:text-teal-200">{t('footer.contactUs')}</Link>
        </nav>
        
        <div className="flex flex-wrap justify-center space-x-4 md:space-x-6 mb-4">
          <Link to={getLocalizedPath("/termini")} className="hover:text-teal-200">{t('footer.terms')}</Link>
          <Link to={getLocalizedPath("/privacy")} className="hover:text-teal-200">{t('footer.privacy')}</Link>
          <Link to={getLocalizedPath("/cookie")} className="hover:text-teal-200">{t('footer.cookies')}</Link>
        </div>
        
        <div className="text-center">
          <p>&copy; {new Date().getFullYear()} Fast Affiliation. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;